(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-app-reviews"] && !Shopify.designMode) return;
  try {
    
  let itemWrapper = null;
  
  const data = {
    buttons: {
      left: {
        el: null,
        active: false
      },
      right: {
        el: null,
        active: true
      }
    },
    items: {
      elArr: [],
      width: 0,
      totalWidth: 0
    },
    wrapperWidth: 0
  };

  function disableBtn(side) {
    if(!data.buttons[side].el) return;

    data.buttons[side].el.classList.toggle("--disabled", true);
    data.buttons[side].active = false;
  }

  function enableBtn(side) {
    if(!data.buttons[side].el) return;
    
    data.buttons[side].el.classList.toggle("--disabled", false);
    data.buttons[side].active = true;
  }

  function getTranslateX(el) {
    var style = window.getComputedStyle(el);
    var transform = style.transform || style.webkitTransform || style.mozTransform;
  
    if (transform === 'none' || typeof transform === 'undefined') {
      return 0;
    }
  
    if ('DOMMatrix' in window) {
      var matrix = new DOMMatrix(transform);
      return matrix.m41;
    }
  
    var matrixValues = transform.match(/matrix.*\((.+)\)/)?.[1]?.split(', ');
    if (matrixValues && matrixValues.length > 4) {
      return parseFloat(matrixValues[4]) || 0;
    }
  
    return 0;
  }

  function scrollRight() {
    if(!data.buttons.right.active) return;
    
    var current_x = getTranslateX(itemWrapper);
    
    if(current_x % (data.items.width) !== 0) return;
    
    var x_abs = Math.abs(current_x) + data.items.width;
    
    itemWrapper.style.transform = `translate(${current_x - data.items.width}px, 0px)`;

    if(!data.buttons.left.active) {
      enableBtn("left");
    }
    
    if(data.items.totalWidth - x_abs <= data.wrapperWidth + 16) {
      disableBtn("right");
      enableBtn("left");
    }
  }

  function scrollLeft() {
    if(!data.buttons.left.active) return;
    
    var current_x = getTranslateX(itemWrapper);

    if(current_x % (data.items.width) !== 0) return;
    
    var x_abs = Math.abs(current_x) - data.items.width;

    itemWrapper.style.transform = `translate(${current_x + data.items.width}px, 0px)`

    if(!data.buttons.right.active && data.items.totalWidth - x_abs > data.wrapperWidth + 16) {
      enableBtn("right");
    }
    
    if(x_abs <= 0) {
      disableBtn("left");
      enableBtn("right");
    }
  }

  function assignSizes() {
    if(!data.buttons.left.el || !data.buttons.right.el || !itemWrapper || data.items.elArr.length === 0) {
      return;
    }
    
    data.items.width = data.items.elArr[0].getBoundingClientRect().width;
    data.items.totalWidth = data.items.width * data.items.elArr.length;
    
    data.wrapperWidth = itemWrapper.getBoundingClientRect().width;
    
    data.buttons.right.el.addEventListener("click", function() { scrollRight(); });
    data.buttons.left.el.addEventListener("click", function() { scrollLeft(); });
  }
  
  function setup() {
    const breakpointTest = document.querySelector(".theme-reviews-carousel-buttons-wrapper");
    itemWrapper = document.querySelector('.theme-reviews');

    if(!breakpointTest || window.getComputedStyle(breakpointTest).getPropertyValue("display") === "none") {
      if(itemWrapper)
      {itemWrapper.style.transform = "";}
      
      return;
    };
    
    data.buttons.left.el = document.querySelector('.theme-reviews-carousel-buttons > .--disabled');
    data.buttons.right.el = document.querySelector('.theme-reviews-carousel-buttons > button:last-child');
    data.items.elArr = itemWrapper.querySelectorAll('.theme-review-item');

    assignSizes();
    console.debug("setup", data);
  }

  window.addEventListener("resize", function(){
    if(itemWrapper === null) {
      setup();
    }
    
    const breakpointTest = document.querySelector(".theme-reviews-carousel-buttons-wrapper");
    
    if(!breakpointTest || window.getComputedStyle(breakpointTest).getPropertyValue("display") === "none") {
      if(itemWrapper) {
        itemWrapper.style.transform = "";
      }
      
      return;
    };

    assignSizes();
    
    var current_x = getTranslateX(itemWrapper);
  
    var x = current_x;
    
    if(current_x % data.items.width !== 0) {
      var plausible_scrolls = ~~(current_x / data.items.width);

      if(isNaN(plausible_scrolls)) return;

      x = data.items.width * plausible_scrolls;
      x *= -1;
      
      itemWrapper.style.transform = `translate(${x}px, 0px)`;
    }

    if(x >= 0) {
      disableBtn("left");
    } else {
      enableBtn("left");
    }

    if(data.items.totalWidth <= data.wrapperWidth + 16) {
      disableBtn("right");
    } else if(data.items.totalWidth + x > data.wrapperWidth + 16) {
      enableBtn("right");
    }
  });

  if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function() {
      if(!!e.target.attributes["data-shopify-editor-section"].value.split(",").find((x) => x === '"type":"custom-product-results-from-clients"')) {
        setup();
      }
    });
  }
  
  document.addEventListener("DOMContentLoaded", setup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-carousel"] && !Shopify.designMode) return;
  try {
    
  let itemWrapper = document.querySelector('.theme-carousel-wrapper');
  
  const data = {
    buttons: {
      left: {
        el: null,
        active: false
      },
      right: {
        el: null,
        active: true
      }
    },
    items: {
      elArr: [],
      width: 0,
      totalWidth: 0
    },
    wrapperWidth: 0
  };

  function disableBtn(side) {
    if(!data.buttons[side].el) return;

    data.buttons[side].el.classList.toggle("--disabled", true);
    data.buttons[side].active = false;
  }

  function enableBtn(side) {
    if(!data.buttons[side].el) return;
    
    data.buttons[side].el.classList.toggle("--disabled", false);
    data.buttons[side].active = true;
  }

  function getTranslateX(el) {
    var style = window.getComputedStyle(el);
    var transform = style.transform || style.webkitTransform || style.mozTransform;
  
    if (transform === 'none' || typeof transform === 'undefined') {
      return 0;
    }
  
    if ('DOMMatrix' in window) {
      var matrix = new DOMMatrix(transform);
      return matrix.m41;
    }
  
    var matrixValues = transform.match(/matrix.*\((.+)\)/)?.[1]?.split(', ');
    if (matrixValues && matrixValues.length > 4) {
      return parseFloat(matrixValues[4]) || 0;
    }
  
    return 0;
  }

  function scrollRight() {
    if(!data.buttons.right.active) return;
    
    var current_x = getTranslateX(itemWrapper);
    
    if(current_x % (data.items.width) !== 0) return;
    
    var x_abs = Math.abs(current_x) + data.items.width;
    
    itemWrapper.style.transform = `translate(${current_x - data.items.width}px, 0px)`;

    if(!data.buttons.left.active) {
      enableBtn("left");
    }
    
    if(data.items.totalWidth - x_abs <= data.wrapperWidth + 16) {
      disableBtn("right");
      enableBtn("left");
    }
  }

  function scrollLeft() {
    if(!data.buttons.left.active) return;
    
    var current_x = getTranslateX(itemWrapper);

    if(current_x % (data.items.width) !== 0) return;
    
    var x_abs = Math.abs(current_x) - data.items.width;

    itemWrapper.style.transform = `translate(${current_x + data.items.width}px, 0px)`

    if(!data.buttons.right.active && data.items.totalWidth - x_abs > data.wrapperWidth + 16) {
      enableBtn("right");
    }
    
    if(x_abs <= 0) {
      disableBtn("left");
      enableBtn("right");
    }
  }

  function assignSizes() {
    if(!data.buttons.left.el || !data.buttons.right.el || !itemWrapper || data.items.elArr.length === 0) {
      return;
    }
    
    data.items.width = data.items.elArr[0].getBoundingClientRect().width + 8;
    data.items.totalWidth = data.items.width * data.items.elArr.length;
    
    data.wrapperWidth = itemWrapper.getBoundingClientRect().width;
    
    data.buttons.right.el.addEventListener("click", function() { scrollRight(); });
    data.buttons.left.el.addEventListener("click", function() { scrollLeft(); });
  }
  
  function setup() {    
    itemWrapper = document.querySelector('.theme-carousel-wrapper');

    if(!itemWrapper) return;
    
    data.buttons.left.el = document.querySelector('.theme-carousel-buttons > .--disabled');
    data.buttons.right.el = document.querySelector('.theme-carousel-buttons > button:last-child');
    data.items.elArr = itemWrapper.querySelectorAll('.theme-flex-item');

    assignSizes();
  }

  window.addEventListener("resize", function(){
    if(!itemWrapper) return;
    
    assignSizes();
    
    var current_x = getTranslateX(itemWrapper);
  
    var x = current_x;
    
    if(current_x % data.items.width !== 0) {
      var plausible_scrolls = ~~(current_x / data.items.width);

      if(isNaN(plausible_scrolls)) return;

      x = data.items.width * plausible_scrolls;
      x *= -1;
      
      itemWrapper.style.transform = `translate(${x}px, 0px)`;
    }

    if(x >= 0) {
      disableBtn("left");
    } else {
      enableBtn("left");
    }

    if(data.items.totalWidth <= data.wrapperWidth + 16) {
      disableBtn("right");
    } else if(data.items.totalWidth + x > data.wrapperWidth + 16) {
      enableBtn("right");
    }
  });

  if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function() {
      if(!!e.target.attributes["data-shopify-editor-section"].value.split(",").find((x) => x === '"type":"custom-product-results-from-clients"')) {
        setup();
      }
    });
  }
  
  document.addEventListener("DOMContentLoaded", setup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-results-from-clients"] && !Shopify.designMode) return;
  try {
    
  var data = {
    row_wrapper_rect: null,
    group_rect: null,
    current_total_width: null,
    btn_right: null,
    btn_left: null
  }
  
  function disableBtn(el) {
    if(!el) return;

    el.classList.toggle("--disabled", true);
  }

  function enableBtn(el) {
    if(!el) return;
    
    el.classList.toggle("--disabled", false);
  }

  function getTotalWidth(groups, group_rect) {
    var current_total_width = 0;

    for(var i = 0; i < groups.length; i++) {
      current_total_width += group_rect.width;
    }

    return current_total_width;
  }

  function getTranslateX(el) {
    var style = window.getComputedStyle(el);
    var transform = style.transform || style.webkitTransform || style.mozTransform;
  
    if (transform === 'none' || typeof transform === 'undefined') {
      return 0;
    }
  
    if ('DOMMatrix' in window) {
      var matrix = new DOMMatrix(transform);
      return matrix.m41;
    }
  
    var matrixValues = transform.match(/matrix.*\((.+)\)/)?.[1]?.split(', ');
    if (matrixValues && matrixValues.length > 4) {
      return parseFloat(matrixValues[4]) || 0;
    }
  
    return 0;
  }
  
  function scrollRight(row) {
    if(data.btn_right.classList.contains("--disabled")) return;
    
    var current_x = getTranslateX(row);

    if(current_x % data.group_rect.width !== 0) return;
    
    var x_abs = Math.abs(current_x) + data.group_rect.width;

    row.style.transform = `translate(${current_x - data.group_rect.width}px, 0px)`;

    if(data.btn_left.classList.contains("--disabled")) {
      enableBtn(data.btn_left);
    }
    
    if(data.current_total_width - x_abs <= data.row_wrapper_rect.width + 16) {
      disableBtn(data.btn_right);
      enableBtn(data.btn_left);
    }
  }

  function scrollLeft(row) {
    if(data.btn_left.classList.contains("--disabled")) return;
    
    var current_x = getTranslateX(row);

    if(current_x % data.group_rect.width !== 0) return;
    
    var x_abs = Math.abs(current_x) - data.group_rect.width;

    row.style.transform = `translate(${current_x + data.group_rect.width}px, 0px)`

    if(data.btn_right.classList.contains("--disabled") && data.current_total_width - x_abs > data.row_wrapper_rect.width + 16) {
      enableBtn(data.btn_right);
    }
    
    if(x_abs <= 0) {
      disableBtn(data.btn_left);
      enableBtn(data.btn_right);
    }
  }
  
  function setup() {
    var container = document.querySelector(".theme-product-results-from-clients");

    if(!container) return;

    var row_wrapper = container.querySelector(".theme-before-after-row-wrapper");

    if(!row_wrapper) return;

    var row = row_wrapper.querySelector(".theme-before-after-row");

    if(!row) return;
    
    var groups = container.querySelectorAll(".theme-before-after-group");

    if(groups.length === 0) return;

    var row_wrapper_rect = row_wrapper.getBoundingClientRect();
    var group_rect = groups[0].getBoundingClientRect();

    data.row_wrapper_rect = row_wrapper_rect;
    data.group_rect = group_rect;
    
    data.current_total_width = getTotalWidth(groups, group_rect);
    
    data.btn_right = container.querySelector(".--scroll-right > button");
    data.btn_left = container.querySelector(".--scroll-left > button");

    disableBtn(data.btn_left);

    if(data.current_total_width <= data.row_wrapper_rect.width + 16) {
      disableBtn(data.btn_right);
    }

    data.btn_right.addEventListener("click", function() { scrollRight(row); });
    data.btn_left.addEventListener("click", function() { scrollLeft(row); });

    window.addEventListener("resize", function() {
      var row_wrapper_rect = row_wrapper.getBoundingClientRect();
      var group_rect = groups[0].getBoundingClientRect();

      data.row_wrapper_rect = row_wrapper_rect;
      data.group_rect = group_rect;
      
      data.current_total_width = getTotalWidth(groups, group_rect);

      var current_x = getTranslateX(row);
  
      var x = current_x;
      
      if(current_x % data.group_rect.width !== 0) {
        var plausible_scrolls = ~~(current_x / data.group_rect.width);

        if(isNaN(plausible_scrolls)) return;

        x = data.group_rect.width * plausible_scrolls;
        x *= -1;
        
        row.style.transform = `translate(${x}px, 0px)`;
      }

      if(x >= 0) {
        disableBtn(data.btn_left);
      } else {
        enableBtn(data.btn_left);
      }

      if(data.current_total_width <= data.row_wrapper_rect.width + 16) {
        disableBtn(data.btn_right);
      } else if(data.current_total_width + x > data.row_wrapper_rect.width + 16) {
        enableBtn(data.btn_right);
      }
    });
  }

  if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function() {
      if(!!e.target.attributes["data-shopify-editor-section"].value.split(",").find((x) => x === '"type":"custom-product-results-from-clients"')) {
        setup();
      } 
    });
  }
  
  document.addEventListener("DOMContentLoaded", setup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Add your JavaScript here */
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
